import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import CoinGroup from './CoinGroup'
import CoinPairs from './CoinPairs'
import CoinPrice from './CoinPrice'
import MarketMonitor from './MarketMonitor'
import { APPNAME } from 'app/constants/APIKEYS'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminCoinPage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '장운영현황',
			link: '/coin/coingroup',
		},
		{
			title: '해선 종목관리',
			link: '/coin/pair',
		},
		{
			title: '시세관리',
			link: '/coin/price',
		},
		{
			title: '실시간 시세',
			link: '/coin/market',
		},
	]

	const renderContent = () => {
		switch (url) {
			case '/coin/coingroup':
				return <CoinGroup title={'※수정/상장/폐지 시 개발자 문의'} />
			case '/coin/pair':
				return <CoinPairs title={'※수정/상장/폐지 시 개발자 문의'} />
			case '/coin/price':
				return <CoinPrice />
			case '/coin/market':
				return <MarketMonitor />
			default:
				return <CoinGroup title={'※수정/상장/폐지 시 개발자 문의'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME + ' ADMIN GLOBAL - 종목운영'}</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
